module.exports = __webpack_public_path__ + "files/ea0fbc98b115d9533c8a7d5a1ed6c2a7.png";